import { NgModule } from '@angular/core';
import { EnvironmentRibbonComponent } from './environment-ribbon/environment-ribbon.component';

@NgModule({
  imports: [EnvironmentRibbonComponent],
  exports: [EnvironmentRibbonComponent]
})
export class EnvironmentRibbonModule {}
